import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ai.report');
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ai-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ai.report/view.scss */
:host {
  display: block;
}

.report-page {
  min-height: 100%;
}

:host ::ng-deep .report-body {
  color: #18181b;
  font-size: 15px;
  line-height: 1.78;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

:host ::ng-deep .report-body h1 {
  margin: 0 0 10px;
  color: #09090b;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.22;
}

:host ::ng-deep .report-body h2 {
  margin: 34px 0 12px;
  padding-top: 22px;
  border-top: 1px solid #e4e4e7;
  color: #09090b;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.35;
}

:host ::ng-deep .report-body h1 + h2 {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
  color: #52525b;
  font-size: 17px;
  font-weight: 600;
}

:host ::ng-deep .report-body h3 {
  margin: 26px 0 8px;
  color: #18181b;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.45;
}

:host ::ng-deep .report-body p {
  margin: 0 0 14px;
}

:host ::ng-deep .report-body ul {
  margin: 0 0 18px;
  padding-left: 18px;
  color: #52525b;
}

:host ::ng-deep .report-body li {
  margin: 3px 0;
}

:host ::ng-deep .report-body a {
  color: #2563eb;
  text-decoration: underline;
  text-underline-offset: 3px;
}

:host ::ng-deep .report-body code {
  border-radius: 5px;
  background: #f4f4f5;
  padding: 1px 5px;
  color: #3f3f46;
  font-size: 0.92em;
}

:host ::ng-deep .citation {
  display: inline-block;
  margin: 0 1px;
  color: #1d4ed8;
  font-weight: 700;
}

:host ::ng-deep .report-figure {
  margin: 24px 0 10px;
}

:host ::ng-deep .report-figure__canvas {
  overflow: hidden;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  background: #fff;
}

:host ::ng-deep .report-figure svg {
  display: block;
  width: 100%;
  height: auto;
}

:host ::ng-deep .figure-caption {
  margin: 0 0 20px;
  color: #52525b;
  font-size: 13px;
  line-height: 1.65;
}

:host ::ng-deep .report-table-wrap {
  margin: 18px 0 24px;
  overflow-x: auto;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
}

:host ::ng-deep .report-table {
  width: 100%;
  min-width: 780px;
  border-collapse: collapse;
  font-size: 13px;
  line-height: 1.55;
}

:host ::ng-deep .report-table th {
  background: #f4f4f5;
  color: #27272a;
  font-weight: 700;
  text-align: left;
}

:host ::ng-deep .report-table th,
:host ::ng-deep .report-table td {
  border-bottom: 1px solid #e4e4e7;
  padding: 10px 12px;
  vertical-align: top;
}

:host ::ng-deep .report-table tr:last-child td {
  border-bottom: 0;
}

:host ::ng-deep .reference-entry {
  margin-bottom: 9px;
  padding-left: 32px;
  color: #3f3f46;
  font-size: 13px;
  line-height: 1.55;
  text-indent: -32px;
}

@media print {
  :host {
    background: #fff;
  }
  .report-toolbar,
  .report-summary {
    display: none !important;
  }
  .report-page,
  .report-document {
    background: #fff !important;
  }
  .report-document {
    border: 0 !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
  main {
    display: block !important;
    max-width: none !important;
    padding: 0 !important;
  }
}`],
})
export class PageAiReportComponent implements OnInit {
    public loading: boolean = true;
    public error: string = '';
    public report: any = null;
    public content: SafeHtml | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        const { code, data }: any = await wiz.call('load');
        if (code === 200 && data?.report) {
            this.report = data.report;
            this.content = this.sanitizer.bypassSecurityTrustHtml(this.report.html || '');
        } else {
            this.error = data?.message || '보고서를 불러오지 못했습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public print() {
        window.print();
    }
}

export default PageAiReportComponent;